// @flow
import gql from "graphql-tag"
import { pathOr } from "ramda"
import type { Query } from "common/graphql/types"
import type { ID } from "data/enums/types"
import type { ProductGroupName } from "data/app/types"

export type AutocompleteItemType = "product" | "affiliate" | "manufacturer"

export type AutocompleteItem = {
  id: ID,
  name: string,
  type: AutocompleteItemType,
}

export type AutocompleteQueryData = {
  [string]: AutocompleteItem[],
}

type AffiliateItem = { id: string, name: string }
type ProductItem = { id: string, name: string, productGroup: { id: string, name: string } }
type ManufacturerItem = { id: string, name: string }

export const searchAutoCompleteQuery: Query<
  AutocompleteQueryData,
  { productGroups?: ?ProductGroupName[], query: ?string, locationIds?: ?ID[] },
> = {
  gql: gql`
    query searchAutoCompleteQuery(
      $query: String
      $productGroups: [String]
      $locationIds: [Int!]
    ) {
      affiliate {
        list(
          filter: {
            name: $query
            productGroups: $productGroups
            allowed: true
            limit: 5
          }
        ) {
          data {
            id
            name
          }
        }
      }
      product {
        list(
          filter: {
            name: $query
            locationIds: $locationIds
            limit: 5
            availableOnly: true
          }
        ) {
          data {
            id
            name
            productGroup {
              id
              name
            }
          }
        }
      }
      manufacturer {
        list(
          filter: {
            name: $query
            limit: 5
            productGroups: $productGroups
            locationIds: $locationIds
          }
        ) {
          data {
            id
            name
          }
        }
      }
    }
  `,
  transform: (data: {
    affiliate: {
      list: {
        data: AffiliateItem[]
      }
    },
    product: {
      list: {
        data: ProductItem[]
      }
    },
    manufacturer: {
      list: {
        data: ManufacturerItem[]
      }
    }
  }) => {
    // this function is not very pretty, but given we don't have the types from this in the first place
    // it remains partially typed like this
    const addType = (
      type: AutocompleteItemType,
      arr: Array<Object>,
    ): AutocompleteItem[] =>
      arr.map(x => ({
        ...x,
        type,
      }))

    // $Ramda
    const products: Array<ProductItem> = pathOr([], ["product", "list", "data"], data)
    // $Ramda
    const affiliates: Array<Object> = pathOr([], ["affiliate", "list", "data"], data)
    // $Ramda
    const manufacturers: Array<Object> = pathOr([], ["manufacturer", "list", "data"], data)

    return {
      products: addType("product", products),
      affiliates: addType("affiliate", affiliates),
      manufacturers: addType("manufacturer", manufacturers),
    }
  },
}



// WEBPACK FOOTER //
// ./src/data/search/graphql/queries/autocomplete.js